<template>
  <div class="main-div">
    <live-system-top-header></live-system-top-header>
    <div class="bottom-root-div">
      <left-menu ref="leftMenu" class="left-menu" @menuItemClick="leftMenuItemClick"></left-menu>
      <router-view class="right-root-div"></router-view>
    </div>
  </div>
</template>

<script>
import TopHeader from '../../components/TopHeader'
import LiveSystemTopHeader from '../../components/live/LiveSystemTopHeader'
import LeftMenu from '../../components/live/LeftMenu'
export default {
  name: 'TeaSystemIndex',
  components: {LeftMenu, LiveSystemTopHeader, TopHeader},
  data () {
    return {
      msg: 'Welcome to Your Vue.js App'
    }
  },
  watch: {
    '$route': {
      handler (route) {
        const that = this
        if (route.path === '/teaIndex') {
          that.getUserMenuData()
        }
      },
      deep: true
    }
  },
  created () {
    this.getUserMenuData()
  },
  mounted () {

  },
  methods: {
    getUserMenuData () {
      let routerPath = this.$route.path
      let selectToday = (routerPath === '/teaIndex/' || routerPath === '/teaIndex')
      let selectedCourse = routerPath === '/teaIndex/courses'
      let selectMessage = routerPath === '/teaIndex/message'
      let selectCloudDisk = routerPath === '/teaIndex/clouddiskop'
      let selectTeaCloudDisk = routerPath === '/teaIndex/teaclouddiskop'
      let menuList = [
        {title: '今日课程', path: '', selected: selectToday},
        {title: '我的课程', path: 'courses', selected: selectedCourse},
        {title: '消息', path: 'message', selected: selectMessage}]
      let cloudDiskMenu = {title: '机构云盘', path: 'clouddiskop', selected: selectCloudDisk}
      let teacherCloudDiskMenu = {title: '老师云盘', path: 'teaclouddiskop', selected: selectTeaCloudDisk}
      menuList.push(cloudDiskMenu)
      menuList.push(teacherCloudDiskMenu)
      this.$api.home.getAdminMenuData().then((res) => {
        console.log(res.data)
        this.$refs.leftMenu.setMenuList(menuList)
      })
    },
    leftMenuItemClick (item) {
      let path = '/teaIndex/' + item.path
      this.$router.push(path)
    },
    formatLeftMenu (menuList) {
      for (let i = 0; i < menuList.length; i++) {
        let item = menuList[i]
        if (item.subMenus != null && item.subMenus !== undefined && item.subMenus.length > 0) {
          for (let j = 0; j < item.subMenus.length; j++) {
            let subItem = item.subMenus[j]
            // if (subItem)
          }
        }
      }
    }
  }
}
</script>

<style lang="less" scoped>
  @import '../../style/mixin-bak';
  .main-div{
    background-color: #F0F0F0;
  }
  .bottom-root-div{
    margin: 0 auto;
    margin-top: 20px;
    width: 1200px;
    height: 100%;
  }
  .left-menu{
    height: 400px;
    width: 230px;
    float: left;
  }
  .right-root-div{
    margin-left: 20px;
    width: 950px;
    float: right;
    background-color: #FFFFFF;
  }

</style>



// WEBPACK FOOTER //
// src/page/teaSystem/TeaSystemIndex.vue